import {
  Component,
  Input,
  Output,
  ChangeDetectionStrategy,
  EventEmitter
} from '@angular/core';
import { Article, Topic } from './help.domain';
import { HelpService } from './help.service';

@Component({
  selector: 'td-wb-help-article-index',
  templateUrl: 'help-article-index.component.html',
  styleUrls: ['help-article-index.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpArticleIndexComponent {
  @Input() topic: Topic;
  @Input() articles: Array<Article>;
  @Output() articleSelected: EventEmitter<string> = new EventEmitter<string>();

  constructor(private helpService: HelpService) {
  }

  scrollToArticle(articleId: string): void {
    if (this.articles.some((item: Article): boolean => item.id === articleId)) {
      this.helpService.scrollToArticle(articleId);
    }
    this.articleSelected.emit(articleId);
  }

  scrollToLink(linkId: string): void {
    this.helpService.scrollToLink(linkId);
  }
}
